/**
 * Game utility functions (duplicated from server for client-side calculations)
 */

const VOWELS = new Set(['A', 'E', 'I', 'O', 'U', 'Y']); // Y comes from the vowel pile (matches server tiles.py)

/**
 * Check if a letter is a vowel
 */
export function isVowel(letter: string): boolean {
  return VOWELS.has(letter.toUpperCase());
}

/**
 * Score table for word lengths
 * 4 letters = 1 point
 * 5 letters = 2 points
 * 6 letters = 4 points
 * 7 letters = 7 points
 * 8+ letters = 10 points + 5 for each additional letter
 */
const SCORE_TABLE: Record<number, number> = {
  4: 1,
  5: 2,
  6: 4,
  7: 7,
  8: 10,
};

/**
 * Calculate score for a word based on its length
 */
export function calculateScore(wordLength: number): number {
  if (wordLength < 4) {
    return 0;
  }
  if (wordLength <= 8) {
    return SCORE_TABLE[wordLength];
  }
  // 9+ letters: 10 base + 5 per extra letter beyond 8
  return 10 + 5 * (wordLength - 8);
}
